import type { ProductFeature as ProductFeatureSchema } from '@amplience/content-types/typings/c-product-feature';
import { ImagePartial } from '@storefront/lib-global/partials/image';
import { TypographyStyles, TypographyStylesType, colours } from '@storefront/lib-global/stylings';
import { getLocalizedValue } from '@storefront/lib-global/utils/transformers';
import {
  Content,
  FeatureContentHeader,
  FeatureContentImage,
  FeatureContentRichText,
  FeatureContentWrapper,
} from './FeatureContent.styles';

type FeatureContentProps = ProductFeatureSchema;

export function FeatureContent({
  productFeatureHeader,
  productFeatureRichText,
  productFeatureImage,
}: FeatureContentProps) {
  return (
    <FeatureContentWrapper>
      <FeatureContentHeader
        {...productFeatureHeader}
        defaultTextSize={TypographyStylesType.BODY_MEDIUM_SEMIBOLD}
        defaultTextColor={colours.BLACK}
      />
      <Content>
        <FeatureContentImage>
          <ImagePartial
            altText={productFeatureImage?.altText}
            layout="intrinsic"
            src={productFeatureImage?.image?.name ?? ''}
            height={40}
            width={50}
            assetType={productFeatureImage?.assetType}
            defaultHost={productFeatureImage?.image?.defaultHost}
            useOriginalSize={productFeatureImage?.useOriginalSize}
          />
        </FeatureContentImage>

        <FeatureContentRichText
          text={getLocalizedValue(productFeatureRichText?.richText)}
          fontSize={TypographyStyles.Body.Small.Regular}
        />
      </Content>
    </FeatureContentWrapper>
  );
}
